"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/atoms/Loading/Loading.tsx
import { jsx } from "react/jsx-runtime";
var Loading = ({ isLoading, children }) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      "data-testid": "loading",
      className: "flex gap-4 lg:gap-8 justify-center items-center w-full",
      children: isLoading ? /* @__PURE__ */ jsx(Icon_default, { name: "signalLoader", className: "animate-spin fill-current" }) : children
    }
  );
};
var Loading_default = Loading;

export {
  Loading_default
};
